import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

const SingleColumnBanner = styled.div`
  display: flex;
  width: 100%;
  ${(props: { orange?: boolean }) => (props.orange ? `background-color: ${COLORS.darkOrange}; min-height: 90px;` : `background-color: ${COLORS.lightBlue}; min-height: 135px;`)}
  color: ${COLORS.white};
  text-align: center;
  justify-content: center;

  .first-line {
    font-size: 16px;
    line-height: 20px;
    padding-bottom: 16px;
  }

  .second-line {
    font-size: 42px;
    line-height: 52px;
    padding-bottom: 16px;
  }

  .third-line {
    line-height: 26px;
    font-size: 23px;
    padding-bottom: 10px;
  }

  .fourth-line {
    font-size: 18px;
    line-height: 20px;
    padding-bottom: 16px;
  }

  .single-line {
    font-size: 42px;
    line-height: 52px;
  }
`;

export default SingleColumnBanner;
